<template>
	<div>
		<p class='t-right'>Completed Tasks: {{todos.filter(todo => todo.done === true).length}}</p>
		<p class='t-right'>Pending Tasks: {{todos.filter(todo => todo.done === false).length}}</p>

		<todo
			v-for="todo in todos"
			v-bind:key="todo.id"
			v-bind:todo="todo"
			v-on:complete-todo="completeTodo"
			v-on:delete-todo="deleteTodo"
		/>

	</div>
</template>

<script type='text/javascript'>
	import Todo from './Todo'
	export default {
		props: ['todos'],
		components: {
			Todo
		},
		methods: {
			todoIndex(todo) {
				return this.todos.indexOf(todo)
			},
			deleteTodo(todo) {
				this.todos.splice(this.todoIndex(todo), 1)
			},
			completeTodo(todo) {
				this.todos[this.todoIndex(todo)].done = true
			}
		}
	}
</script>

<style>
	.t-right {
		text-align: right;
	}

</style>



// WEBPACK FOOTER //
// src/components/TodoList.vue